import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import FavouriteIcon from '../../../Icons/Favourite';
import Who from '../../../Who';
import SplitStatLayout from '../StatLayout/SplitStatLayout';
import { MobileContext } from '../../../Context';
import { BiLoggerContextProvider, BiEventType } from '../../../biLogger';
import { getDeviationResourceType } from '../../../DeviationViews/_helpers';
export var FavouriteStat = function (_a) {
    var deviation = _a.deviation, _b = _a.deviation, isFavourited = _b.isFavourited, author = _b.author, _c = _b.stats, favourites = (_c === void 0 ? { favourites: 0 } : _c).favourites, isCollectionPanelOpen = _a.isCollectionPanelOpen, isOwner = _a.isOwner, onToggleCollectionPanel = _a.onToggleCollectionPanel, onShowMobileCollectionsPanel = _a.onShowMobileCollectionsPanel, actionBarType = _a.actionBarType;
    var t = useTranslation().t;
    var isMobile = useContext(MobileContext);
    var onClick = function () {
        return isMobile
            ? onShowMobileCollectionsPanel(deviation)
            : onToggleCollectionPanel(actionBarType);
    };
    return (React.createElement(SplitStatLayout, { id: "favebutton-" + actionBarType, icon: FavouriteIcon, tooltip: isCollectionPanelOpen
            ? undefined
            : {
                tooltipKey: 'actionbar.addToFavourites',
                renderPopover: function () { return (React.createElement(BiLoggerContextProvider, { value: { sectionname: 'fave_pop_up' } },
                    React.createElement(Who, { deviation: deviation, userListType: "favourite", headline: t('actionbar.users.who.faved') }))); },
                positionOnly: true,
            }, isActive: isFavourited, onClick: isOwner ? undefined : onClick, value: favourites, hasValue: true, biEventData: isCollectionPanelOpen
            ? undefined
            : {
                evid: BiEventType.ADD_TO_COLLECTION_CLICK,
                creatorid: author && author.useridUuid,
                typeid: getDeviationResourceType(deviation),
                itemid: deviation.deviationId,
                sectionname: undefined,
            } }));
};
FavouriteStat.displayName = 'FavouriteStat';
export default FavouriteStat;
//# sourceMappingURL=FavouriteStat.js.map